import { database } from "./firebaseConfig";
import { ref, set, get } from "firebase/database";
import { useState, useEffect } from "react";

const KEYS = { campaigns:"braco:campaigns", pitches:"braco:pitches", users:"braco:users", notifications:"braco:notifications" };
const db = {
  async get(key) {
    try {
      const snapshot = await get(ref(database, key));
      return snapshot.exists() ? snapshot.val() : null;
    } catch (error) {
      console.error("Firebase read error:", error);
      return null;
    }
  },
  async set(key, val) {
    try {
      await set(ref(database, key), val);
    } catch (error) {
      console.error("Firebase write error:", error);
    }
  },
};
const SEED_USERS = [
  { id:"admin-1", role:"admin", email:"admin@braco.co", password:"braco2024", name:"Braco Admin" },
  { id:"brand-1", role:"brand", email:"hello@example.com", password:"brand123", name:"Nike Brand", company:"Nike" },
  { id:"inf-1", role:"influencer", email:"agency@pitch.com", password:"pitch123", name:"Pulse Agency", agency:true },
  { id:"inf-2", role:"influencer", email:"creator@test.com", password:"creator123", name:"Mia Patel", agency:false },
];
const SEED_CAMPAIGNS = [
  { id:"camp-1", status:"Open", submittedAt:"2025-06-01", campaignName:"Summer Glow Collection", brandName:"LuminSkin", contactName:"Sarah Chen", contactEmail:"sarah@luminskin.com", currency:"USD", budgetMin:"5000", budgetMax:"15000", platforms:["Instagram","TikTok"], niche:"Beauty & Skincare", targetAudience:"Women 18-35, US/UK", deliverables:["Reels","Stories","Posts"], timeline:"July 1 – Aug 31, 2025", contentGuidelines:"Authentic, lifestyle-focused content. No heavy filters. Show product in natural light.", referenceLinks:"https://luminskin.com/summer", deadline:"2025-06-25", internalNotes:"" },
  { id:"camp-2", status:"Reviewing", submittedAt:"2025-05-28", campaignName:"Protein Pro Launch", brandName:"FuelFit", contactName:"James Wilson", contactEmail:"james@fuelfit.com", currency:"USD", budgetMin:"10000", budgetMax:"30000", platforms:["YouTube","Instagram"], niche:"Fitness & Health", targetAudience:"Men 20-40, fitness enthusiasts", deliverables:["YouTube Reviews","Instagram Posts"], timeline:"July 15 – Sep 15, 2025", contentGuidelines:"Focus on performance benefits. Before/after welcome. Keep it energetic.", referenceLinks:"", deadline:"2025-06-20", internalNotes:"High priority — follow up with agency pitches" },
  { id:"camp-3", status:"Open", submittedAt:"2025-06-05", campaignName:"Wanderlust 2025 Campaign", brandName:"NomadGear", contactName:"Elena Torres", contactEmail:"elena@nomadgear.com", currency:"USD", budgetMin:"8000", budgetMax:"25000", platforms:["Instagram","TikTok","YouTube"], niche:"Travel", targetAudience:"Travelers 25-45, global", deliverables:["Posts","Reels","YouTube Videos"], timeline:"Aug 1 – Oct 31, 2025", contentGuidelines:"Showcase real travel moments. Authentic destinations, no staged shots.", referenceLinks:"", deadline:"2025-07-10", internalNotes:"" },
  { id:"camp-4", status:"Open", submittedAt:"2025-06-08", campaignName:"UrbanEdge Fall Drop", brandName:"ThreadsCo", contactName:"Maya Patel", contactEmail:"maya@threadsco.com", currency:"USD", budgetMin:"6000", budgetMax:"18000", platforms:["Instagram","TikTok"], niche:"Fashion & Lifestyle", targetAudience:"Gen Z & Millennials 18-30, US", deliverables:["Reels","Posts","Stories"], timeline:"Sep 1 – Oct 31, 2025", contentGuidelines:"Street style, urban aesthetic. Mix of studio and outdoor content.", referenceLinks:"", deadline:"2025-07-20", internalNotes:"" },
];
const SEED_PITCHES = [
  { id:"pitch-1", campaignId:"camp-2", submittedAt:"2025-06-03", agencyName:"Pulse Agency", submittedBy:"inf-1", status:"Shortlisted", pitchNote:"We represent 3 top fitness creators with a combined reach of 8M followers. All have high engagement rates and proven track records with supplement brands.", influencers:[
    { id:"i1", name:"Alex Rivera", handle:"@alexfitpro", platform:"YouTube", followers:"2.1M", engagement:"4.8%", niche:"Fitness", rateCard:"$3,500", sampleLinks:"https://youtube.com/alexfitpro" },
    { id:"i2", name:"Priya Sharma", handle:"@priyalifts", platform:"Instagram", followers:"890K", engagement:"6.2%", niche:"Fitness", rateCard:"$1,800", sampleLinks:"https://instagram.com/priyalifts" },
    { id:"i3", name:"Marcus Stone", handle:"@marcusstone", platform:"YouTube", followers:"5.2M", engagement:"3.9%", niche:"Health & Wellness", rateCard:"$7,200", sampleLinks:"https://youtube.com/marcusstone" },
  ], internalNotes:"Strong agency — follow up on Marcus.", adminReviewed:true },
  { id:"pitch-2", campaignId:"camp-1", submittedAt:"2025-06-10", agencyName:"Mia Patel", submittedBy:"inf-2", status:"Pending", pitchNote:"I create beauty and lifestyle content with a focus on clean skincare routines. My audience is exactly your target demographic.", influencers:[
    { id:"i4", name:"Mia Patel", handle:"@miapatel", platform:"Instagram", followers:"320K", engagement:"7.1%", niche:"Beauty & Skincare", rateCard:"$900", sampleLinks:"https://instagram.com/miapatel" },
  ], internalNotes:"", adminReviewed:false },
];

const uid = () => "id-" + Math.random().toString(36).slice(2, 9);
const fmt = (d) => new Date(d).toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" });
const PLATFORMS = ["Instagram","YouTube","TikTok","Twitter/X","LinkedIn","Pinterest"];
const NICHES = ["Beauty & Skincare","Fitness & Health","Fashion & Lifestyle","Food & Beverage","Tech & Gaming","Travel","Finance","Education","Parenting","Sustainability"];
const DELIVERABLES = ["Posts","Reels","Stories","YouTube Videos","YouTube Shorts","TikTok Videos","Live Streams","Podcast Mentions"];
const CURRENCIES = ["USD","EUR","GBP","CAD","AUD","INR","AED","SGD","MXN","BRL"];

const C = {
  green:"#0D6B50", greenLight:"#12856A", greenBg:"#E8F5F1", greenText:"#0A5440",
  ink:"#0F1117", ink80:"#2A2D35", ink60:"#555963", ink40:"#8C8F98", ink20:"#C8CAD0", ink10:"#E8E9EC", ink05:"#F4F5F7",
  white:"#FFFFFF",
  purple:"#5B4CF5", purpleBg:"#EEECFE", purpleText:"#3B2DB0",
  amber:"#C47A16", amberBg:"#FEF3E2", amberText:"#7A4B09",
  red:"#C0392B", redBg:"#FDECEA", redText:"#7B1D14",
  blue:"#1A6FAE", blueBg:"#E8F2FB", blueText:"#0D4577",
};

const STATUS_MAP = {
  Open:{ bg:C.greenBg, text:C.greenText, dot:C.green },
  Reviewing:{ bg:C.amberBg, text:C.amberText, dot:C.amber },
  Closed:{ bg:"#F0F0F0", text:C.ink60, dot:C.ink40 },
  Shortlisted:{ bg:C.blueBg, text:C.blueText, dot:C.blue },
  Approved:{ bg:C.greenBg, text:C.greenText, dot:C.green },
  Rejected:{ bg:C.redBg, text:C.redText, dot:C.red },
  Pending:{ bg:C.ink10, text:C.ink60, dot:C.ink40 },
  Selected:{ bg:C.purpleBg, text:C.purpleText, dot:C.purple },
  Draft:{ bg:C.ink10, text:C.ink60, dot:C.ink40 },
};

const NICHE_COLORS = {
  "Beauty & Skincare":["#FBE8F0","#8B1A4A"],
  "Fitness & Health":["#E8F5F1","#0A5440"],
  "Fashion & Lifestyle":["#F0EEFB","#3B2DB0"],
  "Food & Beverage":["#FEF3E2","#7A4B09"],
  "Tech & Gaming":["#E6F0FC","#0D4577"],
  "Travel":["#E3F3FB","#0A4A6E"],
  "Finance":["#EDFBF3","#0A5440"],
  "Education":["#FEF3E2","#7A4B09"],
  "Parenting":["#FBE8F0","#8B1A4A"],
  "Sustainability":["#E8F5F1","#0A5440"],
};
const NICHE_ICONS = {
  "Beauty & Skincare":"✦","Fitness & Health":"◈","Fashion & Lifestyle":"◇",
  "Food & Beverage":"◉","Tech & Gaming":"⬡","Travel":"◎","Finance":"⬟",
  "Education":"△","Parenting":"○","Sustainability":"◐",
};

const GS = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,400;0,9..144,500;1,9..144,300;1,9..144,400&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
    body,#root{font-family:'Inter',system-ui,sans-serif;background:${C.ink05};color:${C.ink};}
    input,select,textarea,button{font-family:inherit;}
    ::placeholder{color:${C.ink40};}
    input:focus,select:focus,textarea:focus{outline:2px solid ${C.green};outline-offset:1px;}
    .hl:hover{transform:translateY(-2px);transition:transform 0.18s;}
    .hr:hover{background:${C.ink05}!important;}
    .ba{transition:all 0.15s ease;}
    .ba:hover{opacity:0.88;transform:translateY(-1px);}
    .ba:active{transform:translateY(0);}
    @keyframes fi{from{opacity:0;transform:translateY(10px);}to{opacity:1;transform:translateY(0);}}
    .fi{animation:fi 0.28s ease forwards;}
    @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.4;}}
    .pulse{animation:pulse 2s infinite;}
    ::-webkit-scrollbar{width:5px;}
    ::-webkit-scrollbar-track{background:transparent;}
    ::-webkit-scrollbar-thumb{background:${C.ink20};border-radius:10px;}
  `}</style>
);

// ─── Primitives ──────────────────────────────────────────────────────────────
function Badge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.Pending;
  return (
    <span style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 10px",borderRadius:100,fontSize:12,fontWeight:500,background:s.bg,color:s.text,whiteSpace:"nowrap"}}>
      <span style={{width:6,height:6,borderRadius:"50%",background:s.dot,flexShrink:0}}/>
      {status}
    </span>
  );
}

function Pill({ children, bg = C.ink05, color = C.ink60 }) {
  return <span style={{display:"inline-block",padding:"3px 10px",borderRadius:100,fontSize:12,fontWeight:500,background:bg,color,whiteSpace:"nowrap"}}>{children}</span>;
}

function Btn({ children, onClick, variant="primary", size="md", disabled, style, full }) {
  const base = {cursor:disabled?"not-allowed":"pointer",borderRadius:10,fontWeight:500,border:"none",transition:"all 0.15s ease",opacity:disabled?0.5:1,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6,whiteSpace:"nowrap"};
  const sizes = {xs:{padding:"4px 10px",fontSize:12},sm:{padding:"7px 15px",fontSize:13},md:{padding:"10px 20px",fontSize:14},lg:{padding:"13px 28px",fontSize:15}};
  const variants = {
    primary:{background:C.green,color:"#fff"},
    dark:{background:C.ink,color:"#fff"},
    secondary:{background:C.white,color:C.ink,border:`1px solid ${C.ink20}`},
    ghost:{background:"transparent",color:C.ink60,border:`1px solid ${C.ink20}`},
    danger:{background:C.red,color:"#fff"},
    accent:{background:C.purple,color:"#fff"},
    outline:{background:"transparent",color:C.green,border:`1.5px solid ${C.green}`},
  };
  return (
    <button onClick={onClick} disabled={disabled} className="ba"
      style={{...base,...sizes[size],...variants[variant],...(full?{width:"100%"}:{}),...style}}>
      {children}
    </button>
  );
}

const iS = (extra={}) => ({width:"100%",padding:"10px 14px",border:`1px solid ${C.ink20}`,borderRadius:10,fontSize:14,background:C.white,color:C.ink,boxSizing:"border-box",...extra});

function Input({ label, value, onChange, type="text", placeholder, required, hint, style:ex }) {
  return (
    <div style={{marginBottom:16}}>
      {label&&<label style={{display:"block",fontSize:13,fontWeight:500,color:C.ink60,marginBottom:6}}>{label}{required&&<span style={{color:C.red}}> *</span>}</label>}
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={iS(ex||{})}/>
      {hint&&<p style={{fontSize:12,color:C.ink40,marginTop:4}}>{hint}</p>}
    </div>
  );
}
function Sel({ label, value, onChange, options, required }) {
  return (
    <div style={{marginBottom:16}}>
      {label&&<label style={{display:"block",fontSize:13,fontWeight:500,color:C.ink60,marginBottom:6}}>{label}{required&&<span style={{color:C.red}}> *</span>}</label>}
      <select value={value} onChange={e=>onChange(e.target.value)} style={iS({appearance:"none",paddingRight:36,backgroundImage:`url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 7L11 1' stroke='%238C8F98' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E")`,backgroundRepeat:"no-repeat",backgroundPosition:"right 14px center"})}>
        {options.map(o=><option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}
function TA({ label, value, onChange, rows=3, placeholder, required, hint }) {
  return (
    <div style={{marginBottom:16}}>
      {label&&<label style={{display:"block",fontSize:13,fontWeight:500,color:C.ink60,marginBottom:6}}>{label}{required&&<span style={{color:C.red}}> *</span>}</label>}
      <textarea value={value} onChange={e=>onChange(e.target.value)} rows={rows} placeholder={placeholder} style={iS({resize:"vertical",lineHeight:1.6})}/>
      {hint&&<p style={{fontSize:12,color:C.ink40,marginTop:4}}>{hint}</p>}
    </div>
  );
}
function ChkGroup({ label, options, selected, onChange }) {
  const toggle = o => onChange(selected.includes(o)?selected.filter(x=>x!==o):[...selected,o]);
  return (
    <div style={{marginBottom:16}}>
      {label&&<label style={{display:"block",fontSize:13,fontWeight:500,color:C.ink60,marginBottom:8}}>{label}</label>}
      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
        {options.map(o=>{
          const on=selected.includes(o);
          return (
            <label key={o} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 14px",border:`1.5px solid ${on?C.green:C.ink20}`,borderRadius:100,cursor:"pointer",fontSize:13,fontWeight:on?500:400,background:on?C.greenBg:"transparent",color:on?C.greenText:C.ink60,transition:"all 0.12s"}}>
              <input type="checkbox" checked={on} onChange={()=>toggle(o)} style={{display:"none"}}/>
              {on&&<span style={{width:6,height:6,borderRadius:"50%",background:C.green}}/>}
              {o}
            </label>
          );
        })}
      </div>
    </div>
  );
}

function Card({ children, style, onClick, hover }) {
  return (
    <div className={hover?"hl":""} onClick={onClick}
      style={{background:C.white,border:`1px solid ${C.ink10}`,borderRadius:16,...style}}>
      {children}
    </div>
  );
}

function Divider({ label }) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:12,margin:"20px 0 16px"}}>
      <span style={{fontSize:11,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:C.ink40,whiteSpace:"nowrap"}}>{label}</span>
      <div style={{flex:1,height:1,background:C.ink10}}/>
    </div>
  );
}

function InfoBox({ children, variant="info" }) {
  const m = {info:{bg:C.blueBg,border:C.blue,text:C.blueText},success:{bg:C.greenBg,border:C.green,text:C.greenText},warning:{bg:C.amberBg,border:C.amber,text:C.amberText},lock:{bg:"#F5F0FF",border:C.purple,text:C.purpleText}};
  const s = m[variant]||m.info;
  return <div style={{background:s.bg,borderLeft:`3px solid ${s.border}`,borderRadius:10,padding:"12px 16px",fontSize:13,color:s.text,lineHeight:1.6,marginBottom:18}}>{children}</div>;
}

function Modal({ open, onClose, title, subtitle, children, width=700 }) {
  if(!open) return null;
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(15,17,23,0.65)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="fi" style={{background:C.white,borderRadius:20,width:"100%",maxWidth:width,maxHeight:"92vh",overflowY:"auto",border:`1px solid ${C.ink10}`}}>
        <div style={{padding:"22px 28px 18px",borderBottom:`1px solid ${C.ink10}`,position:"sticky",top:0,background:C.white,zIndex:1,borderRadius:"20px 20px 0 0"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <h2 style={{fontFamily:"'Fraunces',serif",fontSize:20,fontWeight:500,color:C.ink,letterSpacing:"-0.3px"}}>{title}</h2>
              {subtitle&&<p style={{fontSize:14,color:C.ink60,marginTop:3}}>{subtitle}</p>}
            </div>
            <button onClick={onClose} style={{background:C.ink05,border:"none",borderRadius:8,width:32,height:32,cursor:"pointer",fontSize:20,color:C.ink60,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginLeft:16}}>×</button>
          </div>
        </div>
        <div style={{padding:"22px 28px 28px"}}>{children}</div>
      </div>
    </div>
  );
}

// ─── Logo ──────────────────────────────────────────────────────────────────────
function Logo({ size=26, light }) {
  const col = light?"#ffffff":C.ink;
  return (
    <svg width={size*3.6} height={size} viewBox="0 0 108 30" fill="none">
      <text x="0" y="24" fontFamily="Fraunces,Georgia,serif" fontWeight="400" fontSize="26" fill={col} letterSpacing="-1">braco</text>
      <circle cx="100" cy="15" r="7" fill={C.green}/>
      <circle cx="100" cy="15" r="3.5" fill="white" opacity="0.65"/>
    </svg>
  );
}

// ─── Top Nav ──────────────────────────────────────────────────────────────────
function Nav({ user, onNav, onLogout, dark }) {
  const tc = dark?"rgba(255,255,255,0.7)":C.ink60;
  const bc = dark?"rgba(255,255,255,0.2)":C.ink20;
  return (
    <nav style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"0 48px",height:64,background:dark?"transparent":C.white,borderBottom:dark?"none":`1px solid ${C.ink10}`,position:"sticky",top:0,zIndex:100}}>
      <span onClick={()=>onNav("landing")} style={{cursor:"pointer"}}><Logo size={22} light={dark}/></span>
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        {user ? (
          <>
            <span style={{fontSize:13,color:tc,marginRight:4}}>{user.name}</span>
            <Btn variant="ghost" size="sm" style={{color:tc,borderColor:bc}} onClick={()=>onNav(user.role==="influencer"?"dashboard":user.role==="admin"?"admin":"brand-dashboard")}>Dashboard</Btn>
            <Btn variant="ghost" size="sm" style={{color:tc,borderColor:bc}} onClick={onLogout}>Sign out</Btn>
          </>
        ) : (
          <>
            <Btn variant="ghost" size="sm" style={{color:tc,borderColor:"transparent"}} onClick={()=>onNav("catalog")}>Browse campaigns</Btn>
            <Btn variant="ghost" size="sm" style={{color:tc,borderColor:bc}} onClick={()=>onNav("login")}>Sign in</Btn>
            <Btn variant="primary" size="sm" onClick={()=>onNav("brand-brief")}>Submit a brief</Btn>
          </>
        )}
      </div>
    </nav>
  );
}

// ─── Landing Page ─────────────────────────────────────────────────────────────
function Landing({ onNav, user, onLogout }) {
  return (
    <div style={{minHeight:"100vh",background:C.ink05}}>
      <GS/>
      {/* Dark hero */}
      <div style={{background:C.ink,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",inset:0,backgroundImage:`linear-gradient(${C.ink80}18 1px,transparent 1px),linear-gradient(90deg,${C.ink80}18 1px,transparent 1px)`,backgroundSize:"56px 56px",pointerEvents:"none"}}/>
        <div style={{position:"absolute",top:-180,right:-100,width:640,height:640,borderRadius:"50%",background:C.green,opacity:0.07,pointerEvents:"none"}}/>
        <div style={{position:"absolute",bottom:-100,left:-80,width:400,height:400,borderRadius:"50%",background:C.purple,opacity:0.05,pointerEvents:"none"}}/>
        <div style={{position:"relative",zIndex:1}}>
          <Nav user={user} onNav={onNav} onLogout={onLogout} dark/>
          <div style={{maxWidth:1120,margin:"0 auto",padding:"76px 48px 96px"}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:72,alignItems:"center"}}>
              <div className="fi">
                <div style={{display:"inline-flex",alignItems:"center",gap:8,padding:"6px 14px",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:100,fontSize:13,color:"rgba(255,255,255,0.65)",marginBottom:28,fontWeight:500}}>
                  <span style={{width:7,height:7,borderRadius:"50%",background:C.green}} className="pulse"/>
                  Built for agencies & independent creators
                </div>
                <h1 style={{fontFamily:"'Fraunces',serif",fontSize:58,fontWeight:400,lineHeight:1.05,color:"#fff",letterSpacing:"-2px",marginBottom:22}}>
                  Where great<br/>campaigns<br/>
                  <em style={{color:C.greenLight,fontStyle:"italic"}}>find their voice.</em>
                </h1>
                <p style={{fontSize:17,color:"rgba(255,255,255,0.55)",lineHeight:1.75,marginBottom:36,maxWidth:460}}>
                  Braco connects agencies and independent creators with vetted brand campaigns. Browse real briefs, pitch your roster, and close deals — all through one platform.
                </p>
                <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:40}}>
                  <Btn variant="primary" size="lg" onClick={()=>onNav("register")}>Create your account →</Btn>
                  <Btn size="lg" onClick={()=>onNav("catalog")} style={{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.18)",color:"rgba(255,255,255,0.8)",borderRadius:10}}>Browse open campaigns</Btn>
                </div>
                <div style={{display:"flex",gap:32}}>
                  {[["48+","Active campaigns"],["$2.4M","In budgets listed"],["92%","Brand satisfaction"]].map(([n,l])=>(
                    <div key={n}>
                      <div style={{fontFamily:"'Fraunces',serif",fontSize:28,fontWeight:400,color:"#fff"}}>{n}</div>
                      <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",marginTop:2}}>{l}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                {[
                  {icon:"◈",t:"Curated brand briefs",d:"Every listing is personally reviewed by the Braco team before going live. Real budgets, serious brands only."},
                  {icon:"◉",t:"Pitch your full roster",d:"Bundle multiple creators in one submission. Agencies add entire teams per campaign brief."},
                  {icon:"◎",t:"Personal review, always",d:"Every pitch is reviewed personally by Braco. Clear status updates at every stage — no black holes."},
                ].map((f,i)=>(
                  <div key={i} style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:16,padding:"20px 22px",display:"flex",gap:16,alignItems:"flex-start"}}>
                    <div style={{width:42,height:42,borderRadius:12,background:C.green+"1A",display:"flex",alignItems:"center",justifyContent:"center",fontSize:19,color:C.greenLight,flexShrink:0}}>{f.icon}</div>
                    <div>
                      <div style={{fontWeight:600,fontSize:15,color:"rgba(255,255,255,0.88)",marginBottom:5}}>{f.t}</div>
                      <div style={{fontSize:13,color:"rgba(255,255,255,0.4)",lineHeight:1.65}}>{f.d}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Niche strip */}
      <div style={{background:C.greenBg,borderTop:`1px solid ${C.green}20`,borderBottom:`1px solid ${C.green}20`,padding:"16px 48px",overflowX:"auto"}}>
        <div style={{maxWidth:1120,margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"center",gap:40,flexWrap:"wrap"}}>
          {Object.keys(NICHE_ICONS).slice(0,8).map(n=>(
            <div key={n} style={{display:"flex",alignItems:"center",gap:7,fontSize:13,color:C.greenText,fontWeight:500,whiteSpace:"nowrap"}}>
              <span style={{fontSize:15,opacity:0.7}}>{NICHE_ICONS[n]}</span>{n}
            </div>
          ))}
          <span style={{fontSize:13,color:C.green,fontWeight:600}}>+ more →</span>
        </div>
      </div>

      {/* How it works */}
      <div style={{background:C.white,borderBottom:`1px solid ${C.ink10}`}}>
        <div style={{maxWidth:1120,margin:"0 auto",padding:"72px 48px"}}>
          <div style={{display:"flex",alignItems:"flex-end",justifyContent:"space-between",marginBottom:52}}>
            <div>
              <div style={{fontSize:11,fontWeight:600,letterSpacing:"0.1em",textTransform:"uppercase",color:C.green,marginBottom:12}}>How it works</div>
              <h2 style={{fontFamily:"'Fraunces',serif",fontSize:42,fontWeight:400,letterSpacing:"-1px",color:C.ink}}>From browse to booked<br/><em style={{fontStyle:"italic",color:C.ink60}}>in three steps</em></h2>
            </div>
            <Btn variant="outline" onClick={()=>onNav("catalog")}>See open briefs →</Btn>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:20}}>
            {[
              {n:"01",t:"Browse open briefs",d:"Filter by niche, platform, and budget range. Every listing shows exactly what the brand needs and what they're paying."},
              {n:"02",t:"Build your pitch",d:"Add creators from your roster with follower counts, engagement rates, and rate cards. Bundle multiple profiles in one pitch."},
              {n:"03",t:"Get personally selected",d:"Braco reviews every pitch personally. If you're the right fit, you'll be notified and the brand introduction is handled for you."},
            ].map((s,i)=>(
              <div key={s.n} style={{padding:"32px 28px",border:`1px solid ${C.ink10}`,borderRadius:16,background:C.ink05,position:"relative",overflow:"hidden"}}>
                <div style={{position:"absolute",top:-8,right:8,fontSize:88,fontWeight:700,color:C.ink10,fontFamily:"'Fraunces',serif",lineHeight:1,userSelect:"none"}}>{s.n}</div>
                <div style={{position:"relative"}}>
                  <div style={{width:38,height:38,borderRadius:10,background:C.green,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:16,fontWeight:700,fontFamily:"'Fraunces',serif",marginBottom:20}}>{i+1}</div>
                  <h3 style={{fontSize:18,fontWeight:700,marginBottom:10,color:C.ink}}>{s.t}</h3>
                  <p style={{fontSize:14,color:C.ink60,lineHeight:1.7}}>{s.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{background:C.ink,padding:"80px 48px"}}>
        <div style={{maxWidth:680,margin:"0 auto",textAlign:"center"}}>
          <h2 style={{fontFamily:"'Fraunces',serif",fontSize:46,fontWeight:400,color:"#fff",marginBottom:16,letterSpacing:"-1px"}}>Ready to pitch?</h2>
          <p style={{color:"rgba(255,255,255,0.45)",fontSize:16,marginBottom:36,lineHeight:1.7}}>Join agencies and creators already winning campaigns on Braco. Setup takes under two minutes.</p>
          <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
            <Btn variant="primary" size="lg" onClick={()=>onNav("register")}>Create an account →</Btn>
            <Btn size="lg" onClick={()=>onNav("brand-brief")} style={{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.18)",color:"rgba(255,255,255,0.8)",borderRadius:10}}>I'm a brand — submit a brief</Btn>
          </div>
        </div>
      </div>

      <footer style={{padding:"24px 48px",display:"flex",justifyContent:"space-between",alignItems:"center",borderTop:`1px solid ${C.ink10}`,background:C.white}}>
        <Logo size={18}/>
        <p style={{fontSize:13,color:C.ink40}}>© 2025 Braco Inc. · United States · All deals coordinated by Braco.</p>
      </footer>
    </div>
  );
}

// ─── Auth ──────────────────────────────────────────────────────────────────────
function Auth({ mode, onAuth, onSwitch, onNav }) {
  const [email,setEmail]=useState(""); const [pw,setPw]=useState(""); const [pwConfirm,setPwConfirm]=useState(""); const [name,setName]=useState(""); const [company,setCompany]=useState(""); const [role,setRole]=useState("influencer"); const [agency,setAgency]=useState(false); const [err,setErr]=useState(""); const [users,setUsers]=useState([]);
  useEffect(()=>{ db.get(KEYS.users).then(u=>setUsers(u||SEED_USERS)); },[]);
  const handle = async () => {
    setErr("");
    if(mode==="login"){ 
      if(!email||!pw){setErr("Email and password required.");return;}
      const u=users.find(u=>u.email===email&&u.password===pw); 
      if(!u){setErr("Invalid email or password.");return;} 
      onAuth(u); 
    }
    else { 
      if(!name||!email||!pw||!pwConfirm){setErr("All fields required.");return;} 
      if(pw!==pwConfirm){setErr("Passwords don't match.");return;}
      if(pw.length<6){setErr("Password must be at least 6 characters.");return;}
      if(role==="brand"&&!company){setErr("Company name required for brands.");return;}
      if(users.find(u=>u.email===email)){setErr("Email already registered.");return;} 
      const nu={id:uid(),role,email,password:pw,name,company:role==="brand"?company:"",agency:role==="influencer"?agency:false}; 
      const updated=[...users,nu];
      await db.set(KEYS.users,updated);
      setUsers(updated);
      onAuth(nu); 
    }
  };
  return (
    <div style={{minHeight:"100vh",background:C.ink05,display:"flex"}}>
      <GS/>
      {/* Left panel */}
      <div style={{width:"42%",background:C.ink,padding:"48px",display:"flex",flexDirection:"column",position:"relative",overflow:"hidden",flexShrink:0}}>
        <div style={{position:"absolute",bottom:-120,left:-80,width:420,height:420,borderRadius:"50%",background:C.green,opacity:0.07}}/>
        <div style={{position:"absolute",top:80,right:-80,width:280,height:280,borderRadius:"50%",background:C.purple,opacity:0.06}}/>
        <div style={{position:"relative",zIndex:1,display:"flex",flexDirection:"column",height:"100%"}}>
          <span onClick={()=>onNav("landing")} style={{cursor:"pointer"}}><Logo size={22} light/></span>
          <div style={{marginTop:64}}>
            <h2 style={{fontFamily:"'Fraunces',serif",fontSize:36,fontWeight:400,color:"#fff",lineHeight:1.2,letterSpacing:"-0.5px",marginBottom:16}}>
              The influencer<br/>marketplace<br/><em style={{fontStyle:"italic",color:C.greenLight}}>built for scale.</em>
            </h2>
            <p style={{color:"rgba(255,255,255,0.4)",fontSize:14,lineHeight:1.75,maxWidth:300,marginBottom:36}}>Agencies and creators use Braco to discover campaigns, submit pitches, and close brand deals — all through one curated platform.</p>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {["Personally curated brand briefs","Real budgets, serious brands","Braco handles all coordination"].map(t=>(
                <div key={t} style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:18,height:18,borderRadius:"50%",background:C.green,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                  <span style={{fontSize:14,color:"rgba(255,255,255,0.55)"}}>{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Right panel */}
      <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",padding:"48px 64px"}}>
        <div style={{width:"100%",maxWidth:400}} className="fi">
          <h2 style={{fontSize:28,fontWeight:700,color:C.ink,marginBottom:6,letterSpacing:"-0.4px"}}>{mode==="login"?"Welcome back":"Create your account"}</h2>
          <p style={{color:C.ink60,marginBottom:32,fontSize:15}}>{mode==="login"?"Sign in to your Braco account":"Join the Braco marketplace today"}</p>
          {err&&<div style={{background:C.redBg,border:`1px solid ${C.red}30`,borderRadius:10,padding:"11px 14px",fontSize:13,color:C.redText,marginBottom:18}}>{err}</div>}
          {mode==="register"&&(
            <>
              <Input label="Full name or agency name" value={name} onChange={setName} required placeholder="Pulse Agency"/>
              <div style={{marginBottom:16}}>
                <label style={{display:"block",fontSize:13,fontWeight:500,color:C.ink60,marginBottom:8}}>Account type <span style={{color:C.red}}>*</span></label>
                <div style={{display:"flex",gap:8}}>
                  {[["influencer","Creator / Agency"],["brand","Brand"]].map(([v,l])=>(
                    <label key={v} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",padding:"10px 14px",border:`1.5px solid ${role===v?C.green:C.ink20}`,borderRadius:10,cursor:"pointer",fontSize:14,fontWeight:role===v?600:400,background:role===v?C.greenBg:"transparent",color:role===v?C.greenText:C.ink60,transition:"all 0.12s"}}>
                      <input type="radio" value={v} checked={role===v} onChange={()=>{setRole(v);setCompany("");}} style={{display:"none"}}/>{l}
                    </label>
                  ))}
                </div>
              </div>
              {role==="brand"&&(
                <Input label="Company name" value={company} onChange={setCompany} required placeholder="Nike, Adidas, etc."/>
              )}
              {role==="influencer"&&(
                <label style={{display:"flex",alignItems:"center",gap:10,fontSize:14,marginBottom:16,cursor:"pointer",color:C.ink60}}>
                  <div style={{width:18,height:18,borderRadius:5,border:`1.5px solid ${agency?C.green:C.ink20}`,background:agency?C.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.12s"}}>
                    {agency&&<svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                  </div>
                  <input type="checkbox" checked={agency} onChange={e=>setAgency(e.target.checked)} style={{display:"none"}}/>
                  I represent multiple creators (agency)
                </label>
              )}
            </>
          )}
          <Input label="Email address" value={email} onChange={setEmail} type="email" required placeholder="you@agency.com"/>
          <Input label="Password" value={pw} onChange={setPw} type="password" required placeholder="••••••••" hint="Min 6 characters"/>
          {mode==="register"&&(
            <Input label="Confirm password" value={pwConfirm} onChange={setPwConfirm} type="password" required placeholder="••••••••"/>
          )}
          <Btn variant="primary" onClick={handle} full size="lg" style={{marginTop:4}}>{mode==="login"?"Sign in →":"Create account →"}</Btn>
          <p style={{textAlign:"center",fontSize:13,color:C.ink60,marginTop:20}}>
            {mode==="login"?"No account?":"Already have one?"}{" "}
            <span style={{color:C.green,cursor:"pointer",fontWeight:600}} onClick={()=>onSwitch(mode==="login"?"register":"login")}>{mode==="login"?"Create one":"Sign in"}</span>
          </p>
          {mode==="login"&&(
            <div style={{marginTop:20,padding:"14px 16px",background:C.ink05,borderRadius:10,fontSize:12,color:C.ink60,border:`1px solid ${C.ink10}`,lineHeight:1.7}}>
              <div style={{fontWeight:700,color:C.ink80,marginBottom:6,fontSize:13}}>Demo accounts</div>
              Admin: admin@braco.co / braco2024<br/>
              Agency: agency@pitch.com / pitch123<br/>
              Brand: hello@example.com / brand123
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Brand Brief ──────────────────────────────────────────────────────────────
function BrandBrief({ onBack }) {
  const [form,setForm]=useState({campaignName:"",brandName:"",contactName:"",contactEmail:"",currency:"USD",budgetMin:"",budgetMax:"",platforms:[],niche:NICHES[0],targetAudience:"",deliverables:[],timeline:"",contentGuidelines:"",referenceLinks:"",deadline:""});
  const [done,setDone]=useState(false); const [loading,setLoading]=useState(false);
  const f = k => v => setForm(p=>({...p,[k]:v}));
  const submit = async () => {
    if(!form.campaignName||!form.brandName||!form.contactName||!form.contactEmail){alert("Please fill required fields.");return;}
    setLoading(true);
    const cs=await db.get(KEYS.campaigns)||SEED_CAMPAIGNS;
    const nc={...form,id:uid(),status:"Open",submittedAt:new Date().toISOString().split("T")[0],internalNotes:""};
    await db.set(KEYS.campaigns,[...cs,nc]);
    const ns=await db.get(KEYS.notifications)||[];
    await db.set(KEYS.notifications,[...ns,{id:uid(),type:"new_brief",message:`New brief: "${form.campaignName}" from ${form.brandName}`,createdAt:new Date().toISOString(),read:false}]);
    setLoading(false); setDone(true);
  };

  if(done) return (
    <div style={{minHeight:"100vh",background:C.ink05,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <GS/>
      <Card style={{maxWidth:520,width:"100%",padding:"52px 44px",textAlign:"center"}} className="fi">
        <div style={{width:64,height:64,borderRadius:"50%",background:C.greenBg,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 24px"}}>
          <svg width="28" height="22" viewBox="0 0 28 22" fill="none"><path d="M2 12L10 20L26 2" stroke={C.green} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
        <h2 style={{fontFamily:"'Fraunces',serif",fontSize:28,fontWeight:400,marginBottom:10,letterSpacing:"-0.3px"}}>Brief submitted!</h2>
        <p style={{color:C.ink60,lineHeight:1.7,marginBottom:16}}>The Braco team will review your campaign and match you with the right creators. You'll hear from us at <strong style={{color:C.ink}}>{form.contactEmail}</strong>.</p>
        <InfoBox variant="lock">🔒 Your contact info is confidential and never shared with creators. All communication goes through Braco.</InfoBox>
        <Btn variant="primary" onClick={onBack} full>Back to home</Btn>
      </Card>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:C.ink05}}>
      <GS/>
      <div style={{background:C.white,borderBottom:`1px solid ${C.ink10}`,padding:"0 48px",height:56,display:"flex",alignItems:"center",gap:16}}>
        <Logo size={20}/><div style={{width:1,height:20,background:C.ink20}}/>
        <span style={{fontSize:14,color:C.ink60}}>Submit a campaign brief</span>
      </div>
      <div style={{maxWidth:720,margin:"0 auto",padding:"40px 24px"}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.ink60,fontSize:13,display:"flex",alignItems:"center",gap:6,marginBottom:28}}>← Back</button>
        <div style={{marginBottom:28}}>
          <h1 style={{fontFamily:"'Fraunces',serif",fontSize:34,fontWeight:400,letterSpacing:"-0.6px",marginBottom:8}}>Tell us about your campaign</h1>
          <p style={{color:C.ink60,fontSize:15,lineHeight:1.6}}>Your contact details stay private. Braco handles all creator communication on your behalf.</p>
        </div>
        <InfoBox variant="lock">🔒 <strong>Privacy guaranteed.</strong> Your contact information is never shared with creators or published publicly. Braco acts as sole intermediary for all communication.</InfoBox>

        <Card style={{padding:"28px 32px",marginBottom:16}}>
          <Divider label="Campaign details"/>
          <Input label="Campaign name" value={form.campaignName} onChange={f("campaignName")} required placeholder="Summer Glow Collection 2025"/>
          <Input label="Brand name" value={form.brandName} onChange={f("brandName")} required placeholder="Your brand or company name"/>

          <Divider label="Your contact — private, Braco use only"/>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Input label="Your name" value={form.contactName} onChange={f("contactName")} required/>
            <Input label="Your email" value={form.contactEmail} onChange={f("contactEmail")} type="email" required/>
          </div>

          <Divider label="Budget"/>
          <div style={{display:"grid",gridTemplateColumns:"120px 1fr 1fr",gap:16}}>
            <Sel label="Currency" value={form.currency} onChange={f("currency")} options={CURRENCIES}/>
            <Input label="Minimum" value={form.budgetMin} onChange={f("budgetMin")} placeholder="5,000"/>
            <Input label="Maximum" value={form.budgetMax} onChange={f("budgetMax")} placeholder="20,000"/>
          </div>

          <Divider label="Campaign scope"/>
          <Sel label="Niche / Category" value={form.niche} onChange={f("niche")} options={NICHES}/>
          <ChkGroup label="Target platforms" options={PLATFORMS} selected={form.platforms} onChange={f("platforms")}/>
          <ChkGroup label="Deliverables" options={DELIVERABLES} selected={form.deliverables} onChange={f("deliverables")}/>
          <TA label="Target audience demographics" value={form.targetAudience} onChange={f("targetAudience")} placeholder="e.g. Women 25–35, US/UK, interested in skincare and wellness"/>

          <Divider label="Timeline & creative direction"/>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Input label="Campaign timeline" value={form.timeline} onChange={f("timeline")} placeholder="July 1 – Aug 31, 2025"/>
            <Input label="Pitch deadline" value={form.deadline} onChange={f("deadline")} type="date"/>
          </div>
          <TA label="Content guidelines" value={form.contentGuidelines} onChange={f("contentGuidelines")} rows={4} placeholder="Brand voice, dos and don'ts, key messages, aesthetic direction..."/>
          <Input label="Reference links or assets" value={form.referenceLinks} onChange={f("referenceLinks")} placeholder="https://... moodboards, previous campaigns, brand kit..." hint="Optional"/>
          <div style={{marginTop:8}}>
            <Btn variant="primary" onClick={submit} disabled={loading} full size="lg">{loading?"Submitting…":"Submit campaign brief →"}</Btn>
          </div>
        </Card>
      </div>
    </div>
  );
}

// ─── Catalog ──────────────────────────────────────────────────────────────────
function Catalog({ user, onNav, onLogout, onLoginRequired }) {
  const [campaigns,setCampaigns]=useState([]); const [filter,setFilter]=useState({niche:"",platform:"",search:""}); const [sel,setSel]=useState(null); const [pitching,setPitching]=useState(false);
  useEffect(()=>{ db.get(KEYS.campaigns).then(c=>setCampaigns(c||SEED_CAMPAIGNS)); },[]);
  const open=campaigns.filter(c=>c.status==="Open"||c.status==="Reviewing");
  const filtered=open.filter(c=>(!filter.niche||c.niche===filter.niche)&&(!filter.platform||(c.platforms||[]).includes(filter.platform))&&(!filter.search||c.campaignName.toLowerCase().includes(filter.search.toLowerCase())||c.brandName.toLowerCase().includes(filter.search.toLowerCase())));
  return (
    <div style={{minHeight:"100vh",background:C.ink05}}>
      <GS/>
      <Nav user={user} onNav={onNav} onLogout={onLogout}/>
      <div style={{maxWidth:1140,margin:"0 auto",padding:"40px 24px"}}>
        <div style={{marginBottom:28}}>
          <h1 style={{fontFamily:"'Fraunces',serif",fontSize:38,fontWeight:400,letterSpacing:"-0.6px",marginBottom:6}}>Open campaigns</h1>
          <p style={{color:C.ink60,fontSize:15}}>{filtered.length} campaign{filtered.length!==1?"s":""} available to pitch on</p>
        </div>
        {/* Filter bar */}
        <div style={{display:"flex",gap:10,marginBottom:28,flexWrap:"wrap",background:C.white,padding:"14px 18px",borderRadius:14,border:`1px solid ${C.ink10}`,alignItems:"center"}}>
          <div style={{flex:"1 1 220px",position:"relative"}}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",pointerEvents:"none"}}><circle cx="6.5" cy="6.5" r="5" stroke={C.ink40} strokeWidth="1.5"/><path d="M10 10L13 13" stroke={C.ink40} strokeWidth="1.5" strokeLinecap="round"/></svg>
            <input value={filter.search} onChange={e=>setFilter(p=>({...p,search:e.target.value}))} placeholder="Search campaigns…" style={iS({paddingLeft:34})}/>
          </div>
          <select value={filter.niche} onChange={e=>setFilter(p=>({...p,niche:e.target.value}))} style={iS({flex:"0 1 180px",appearance:"none"})}>
            <option value="">All niches</option>
            {NICHES.map(n=><option key={n}>{n}</option>)}
          </select>
          <select value={filter.platform} onChange={e=>setFilter(p=>({...p,platform:e.target.value}))} style={iS({flex:"0 1 160px",appearance:"none"})}>
            <option value="">All platforms</option>
            {PLATFORMS.map(p=><option key={p}>{p}</option>)}
          </select>
          {(filter.search||filter.niche||filter.platform)&&<Btn variant="ghost" size="sm" onClick={()=>setFilter({niche:"",platform:"",search:""})}>Clear</Btn>}
        </div>
        {/* Grid */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:20}}>
          {filtered.map(c=>{
            const nc=NICHE_COLORS[c.niche]||[C.ink05,C.ink60];
            return (
              <Card key={c.id} hover style={{cursor:"pointer",overflow:"hidden"}} onClick={()=>setSel(c)}>
                <div style={{height:5,background:nc[1],opacity:0.6}}/>
                <div style={{padding:"20px 22px 22px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
                    <div style={{width:46,height:46,borderRadius:12,background:nc[0],display:"flex",alignItems:"center",justifyContent:"center",fontSize:21,color:nc[1],fontWeight:700}}>{NICHE_ICONS[c.niche]||"◆"}</div>
                    <Badge status={c.status}/>
                  </div>
                  <h3 style={{fontSize:17,fontWeight:700,color:C.ink,marginBottom:3,letterSpacing:"-0.2px"}}>{c.campaignName}</h3>
                  <p style={{fontSize:13,color:C.ink60,marginBottom:14,fontWeight:500}}>{c.brandName}</p>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:16}}>
                    {(c.platforms||[]).map(p=><Pill key={p} bg={C.ink05} color={C.ink60}>{p}</Pill>)}
                    <Pill bg={nc[0]} color={nc[1]}>{c.niche}</Pill>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",borderTop:`1px solid ${C.ink10}`,paddingTop:14}}>
                    <div>
                      <div style={{fontSize:11,color:C.ink40,fontWeight:600,letterSpacing:"0.04em",marginBottom:2}}>BUDGET</div>
                      <div style={{fontSize:15,fontWeight:700,color:C.ink}}>{c.currency||"USD"} {c.budgetMin}–{c.budgetMax}</div>
                    </div>
                    {c.deadline&&<div style={{textAlign:"right"}}>
                      <div style={{fontSize:11,color:C.ink40,fontWeight:600,letterSpacing:"0.04em",marginBottom:2}}>DEADLINE</div>
                      <div style={{fontSize:13,fontWeight:500,color:C.ink80}}>{c.deadline}</div>
                    </div>}
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
        {filtered.length===0&&<div style={{textAlign:"center",padding:"80px 20px",color:C.ink60}}><div style={{fontSize:40,opacity:0.2,marginBottom:16}}>◎</div><p style={{fontSize:16,marginBottom:12}}>No campaigns match your filters.</p><Btn variant="ghost" size="sm" onClick={()=>setFilter({niche:"",platform:"",search:""})}>Clear filters</Btn></div>}
      </div>

      <Modal open={!!sel} onClose={()=>{setSel(null);setPitching(false);}} title={sel?.campaignName||""} subtitle={sel?.brandName}>
        {sel&&!pitching&&(
          <div>
            <div style={{display:"flex",gap:8,marginBottom:20,flexWrap:"wrap"}}>
              <Badge status={sel.status}/>
              {(sel.platforms||[]).map(p=><Pill key={p} bg={C.ink05} color={C.ink60}>{p}</Pill>)}
              <Pill bg={(NICHE_COLORS[sel.niche]||[C.ink05,C.ink60])[0]} color={(NICHE_COLORS[sel.niche]||[C.ink05,C.ink60])[1]}>{sel.niche}</Pill>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
              {[["Brand",sel.brandName],["Budget",`${sel.currency||"USD"} ${sel.budgetMin}–${sel.budgetMax}`],["Timeline",sel.timeline],["Deadline",sel.deadline?fmt(sel.deadline):"—"]].map(([l,v])=>(
                <div key={l} style={{background:C.ink05,borderRadius:10,padding:"12px 14px"}}>
                  <div style={{fontSize:11,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:4}}>{l}</div>
                  <div style={{fontSize:14,fontWeight:500,color:C.ink}}>{v||"—"}</div>
                </div>
              ))}
            </div>
            {sel.targetAudience&&<div style={{marginBottom:14}}><div style={{fontSize:12,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:5}}>Target Audience</div><p style={{fontSize:14,color:C.ink80,lineHeight:1.65}}>{sel.targetAudience}</p></div>}
            {(sel.deliverables||[]).length>0&&<div style={{marginBottom:14}}><div style={{fontSize:12,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:8}}>Deliverables</div><div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{sel.deliverables.map(d=><Pill key={d} bg={C.purpleBg} color={C.purpleText}>{d}</Pill>)}</div></div>}
            {sel.contentGuidelines&&<div style={{marginBottom:14}}><div style={{fontSize:12,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:5}}>Content Guidelines</div><p style={{fontSize:14,color:C.ink80,lineHeight:1.7}}>{sel.contentGuidelines}</p></div>}
            {sel.referenceLinks&&<div style={{marginBottom:18}}><div style={{fontSize:12,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:5}}>Reference Links</div><a href={sel.referenceLinks} style={{fontSize:14,color:C.green,fontWeight:500}} target="_blank" rel="noreferrer">{sel.referenceLinks} ↗</a></div>}
            <InfoBox variant="warning">All pitches are reviewed personally by the Braco team. Selected creators are introduced to the brand through Braco only.</InfoBox>
            <Btn variant="primary" size="lg" full onClick={()=>{if(!user||user.role!=="influencer"){setSel(null);onLoginRequired();}else setPitching(true);}}>Submit a pitch for this campaign →</Btn>
          </div>
        )}
        {sel&&pitching&&<PitchForm campaign={sel} user={user} onDone={()=>{setSel(null);setPitching(false);}}/>}
      </Modal>
    </div>
  );
}

// ─── Pitch Form ───────────────────────────────────────────────────────────────
function PitchForm({ campaign, user, onDone }) {
  const [note,setNote]=useState(""); const [infs,setInfs]=useState([{id:uid(),name:"",handle:"",platform:"Instagram",followers:"",engagement:"",niche:"",rateCard:"",sampleLinks:""}]); const [busy,setBusy]=useState(false); const [done,setDone]=useState(false);
  const addI=()=>setInfs(p=>[...p,{id:uid(),name:"",handle:"",platform:"Instagram",followers:"",engagement:"",niche:"",rateCard:"",sampleLinks:""}]);
  const removeI=id=>setInfs(p=>p.filter(i=>i.id!==id));
  const upI=(id,k,v)=>setInfs(p=>p.map(i=>i.id===id?{...i,[k]:v}:i));
  const submit=async(draft)=>{
    setBusy(true);
    const ps=await db.get(KEYS.pitches)||SEED_PITCHES;
    const np={id:uid(),campaignId:campaign.id,submittedBy:user.id,agencyName:user.name,status:draft?"Draft":"Pending",pitchNote:note,influencers:infs,submittedAt:new Date().toISOString().split("T")[0],internalNotes:"",adminReviewed:false};
    await db.set(KEYS.pitches,[...ps,np]);
    const ns=await db.get(KEYS.notifications)||[];
    await db.set(KEYS.notifications,[...ns,{id:uid(),type:"new_pitch",message:`New pitch from ${user.name} for "${campaign.campaignName}"`,createdAt:new Date().toISOString(),read:false}]);
    setBusy(false); setDone(true);
  };

  if(done) return (
    <div style={{textAlign:"center",padding:"44px 0"}}>
      <div style={{width:64,height:64,borderRadius:"50%",background:C.greenBg,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 20px"}}>
        <svg width="28" height="22" viewBox="0 0 28 22" fill="none"><path d="M2 12L10 20L26 2" stroke={C.green} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </div>
      <h3 style={{fontFamily:"'Fraunces',serif",fontSize:24,fontWeight:400,marginBottom:8}}>Pitch submitted!</h3>
      <p style={{color:C.ink60,marginBottom:24,lineHeight:1.6,maxWidth:320,margin:"0 auto 24px"}}>The Braco team will personally review your pitch and follow up with feedback.</p>
      <Btn variant="primary" onClick={onDone}>Done</Btn>
    </div>
  );

  return (
    <div>
      <div style={{background:C.ink05,border:`1px solid ${C.ink10}`,borderRadius:10,padding:"12px 16px",fontSize:13,color:C.ink60,marginBottom:20}}>
        Pitching for: <strong style={{color:C.ink}}>{campaign.campaignName}</strong> · {campaign.brandName}
      </div>
      <TA label="Pitch note / cover message" value={note} onChange={setNote} rows={3} placeholder="Why are your creators the right fit for this campaign?"/>
      <Divider label={`Creator roster (${infs.length})`}/>
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10,marginTop:-8}}>
        <Btn variant="ghost" size="sm" onClick={addI}>+ Add creator</Btn>
      </div>
      {infs.map((inf,idx)=>(
        <div key={inf.id} style={{background:C.ink05,border:`1px solid ${C.ink10}`,borderRadius:12,padding:"18px 20px",marginBottom:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div style={{display:"inline-flex",alignItems:"center",gap:8,fontSize:13,fontWeight:600,color:C.green}}>
              <div style={{width:24,height:24,borderRadius:"50%",background:C.greenBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:C.greenText,fontWeight:700}}>#{idx+1}</div>
              Creator #{idx+1}
            </div>
            {infs.length>1&&<button onClick={()=>removeI(inf.id)} style={{background:"none",border:"none",cursor:"pointer",color:C.red,fontSize:13,fontWeight:500}}>Remove</button>}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <Input label="Name" value={inf.name} onChange={v=>upI(inf.id,"name",v)} placeholder="Alex Rivera"/>
            <Input label="Handle" value={inf.handle} onChange={v=>upI(inf.id,"handle",v)} placeholder="@alexrivera"/>
            <Sel label="Platform" value={inf.platform} onChange={v=>upI(inf.id,"platform",v)} options={PLATFORMS}/>
            <Input label="Niche" value={inf.niche} onChange={v=>upI(inf.id,"niche",v)} placeholder="Fitness"/>
            <Input label="Follower count" value={inf.followers} onChange={v=>upI(inf.id,"followers",v)} placeholder="250K"/>
            <Input label="Engagement rate" value={inf.engagement} onChange={v=>upI(inf.id,"engagement",v)} placeholder="4.5%"/>
            <Input label="Rate card" value={inf.rateCard} onChange={v=>upI(inf.id,"rateCard",v)} placeholder="$1,500 per post"/>
            <Input label="Sample content links" value={inf.sampleLinks} onChange={v=>upI(inf.id,"sampleLinks",v)} placeholder="https://..."/>
          </div>
        </div>
      ))}
      <div style={{display:"flex",gap:10}}>
        <Btn variant="ghost" onClick={()=>submit(true)} disabled={busy}>Save as draft</Btn>
        <Btn variant="primary" onClick={()=>submit(false)} disabled={busy} style={{flex:1,justifyContent:"center"}}>Submit pitch →</Btn>
      </div>
    </div>
  );
}

// ─── Influencer Dashboard ─────────────────────────────────────────────────────
function InflDash({ user, onNav, onLogout }) {
  const [pitches,setPitches]=useState([]); const [campaigns,setCampaigns]=useState([]);
  useEffect(()=>{ db.get(KEYS.pitches).then(p=>setPitches((p||SEED_PITCHES).filter(x=>x.submittedBy===user.id))); db.get(KEYS.campaigns).then(c=>setCampaigns(c||SEED_CAMPAIGNS)); },[user.id]);
  const gc=id=>campaigns.find(c=>c.id===id);
  return (
    <div style={{minHeight:"100vh",background:C.ink05}}>
      <GS/>
      <Nav user={user} onNav={onNav} onLogout={onLogout}/>
      <div style={{maxWidth:960,margin:"0 auto",padding:"40px 24px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:32}}>
          <div>
            <p style={{fontSize:13,color:C.ink60,marginBottom:5}}>Welcome back,</p>
            <h1 style={{fontFamily:"'Fraunces',serif",fontSize:34,fontWeight:400,letterSpacing:"-0.5px"}}>{user.name}</h1>
          </div>
          <Btn variant="primary" onClick={()=>onNav("catalog")}>Browse campaigns →</Btn>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:32}}>
          {[["Total pitches",pitches.length,C.ink],["Awaiting review",pitches.filter(p=>p.status==="Pending").length,C.amber],["Shortlisted / Selected",pitches.filter(p=>["Shortlisted","Selected"].includes(p.status)).length,C.green]].map(([l,v,accent])=>(
            <Card key={l} style={{padding:"20px 22px"}}>
              <div style={{fontSize:12,color:C.ink60,fontWeight:500,marginBottom:8}}>{l}</div>
              <div style={{fontFamily:"'Fraunces',serif",fontSize:42,fontWeight:400,color:accent}}>{v}</div>
            </Card>
          ))}
        </div>
        {pitches.length===0?(
          <Card style={{padding:"60px 40px",textAlign:"center"}}>
            <div style={{fontSize:44,color:C.ink20,marginBottom:16}}>◎</div>
            <p style={{color:C.ink60,marginBottom:20,fontSize:15}}>No pitches submitted yet.</p>
            <Btn variant="primary" onClick={()=>onNav("catalog")}>Browse open campaigns →</Btn>
          </Card>
        ):(
          <div>
            <h2 style={{fontSize:18,fontWeight:700,marginBottom:16}}>Your submissions</h2>
            {pitches.map(pitch=>{
              const camp=gc(pitch.campaignId);
              const nc=NICHE_COLORS[camp?.niche]||[C.ink05,C.ink60];
              return (
                <Card key={pitch.id} style={{marginBottom:14,overflow:"hidden"}}>
                  <div style={{height:4,background:nc[1],opacity:0.5}}/>
                  <div style={{padding:"18px 22px 20px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                      <div>
                        <h3 style={{fontSize:16,fontWeight:700,marginBottom:3}}>{camp?.campaignName||"Campaign"}</h3>
                        <p style={{fontSize:13,color:C.ink60}}>{camp?.brandName} · Submitted {fmt(pitch.submittedAt)}</p>
                      </div>
                      <Badge status={pitch.status}/>
                    </div>
                    {pitch.pitchNote&&<p style={{fontSize:13,color:C.ink60,marginBottom:12,fontStyle:"italic",lineHeight:1.6,borderLeft:`3px solid ${C.ink10}`,paddingLeft:12}}>"{pitch.pitchNote}"</p>}
                    <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                      {pitch.influencers.map(inf=><span key={inf.id} style={{fontSize:12,padding:"4px 12px",background:C.purpleBg,borderRadius:100,color:C.purpleText,fontWeight:500}}>{inf.name} · {inf.followers} · {inf.platform}</span>)}
                    </div>
                    {pitch.status==="Selected"&&<div style={{marginTop:14,background:C.greenBg,borderLeft:`3px solid ${C.green}`,borderRadius:10,padding:"12px 16px",fontSize:13,color:C.greenText,fontWeight:500}}>🎉 Your pitch has been selected! The Braco team will reach out to coordinate next steps.</div>}
                  </div>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Brand Dashboard ──────────────────────────────────────────────────────────
function BrandDash({ user, onNav, onLogout }) {
  const [campaigns,setCampaigns]=useState([]);
  useEffect(()=>{ db.get(KEYS.campaigns).then(c=>setCampaigns((c||SEED_CAMPAIGNS).filter(x=>x.contactEmail===user.email||x.brandName?.toLowerCase()===user.company?.toLowerCase()))); },[]);
  return (
    <div style={{minHeight:"100vh",background:C.ink05}}>
      <GS/>
      <Nav user={user} onNav={onNav} onLogout={onLogout}/>
      <div style={{maxWidth:900,margin:"0 auto",padding:"40px 24px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:28}}>
          <div>
            <p style={{fontSize:13,color:C.ink60,marginBottom:5}}>Welcome back,</p>
            <h1 style={{fontFamily:"'Fraunces',serif",fontSize:34,fontWeight:400,letterSpacing:"-0.5px"}}>{user.name}</h1>
          </div>
          <Btn variant="primary" onClick={()=>onNav("brand-brief")}>Submit new brief →</Btn>
        </div>
        <InfoBox variant="success">📬 <strong>All creator outreach goes through Braco.</strong> Your contact info is never shared. You'll be notified when a match is selected.</InfoBox>
        {campaigns.length===0?(
          <Card style={{padding:"60px 40px",textAlign:"center"}}>
            <div style={{fontSize:44,color:C.ink20,marginBottom:16}}>◎</div>
            <p style={{color:C.ink60,marginBottom:20,fontSize:15}}>No campaigns yet.</p>
            <Btn variant="primary" onClick={()=>onNav("brand-brief")}>Submit your first brief →</Btn>
          </Card>
        ):campaigns.map(c=>{
          const nc=NICHE_COLORS[c.niche]||[C.ink05,C.ink60];
          return (
            <Card key={c.id} style={{marginBottom:14,overflow:"hidden"}}>
              <div style={{height:5,background:nc[1],opacity:0.5}}/>
              <div style={{padding:"20px 22px"}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <h3 style={{fontSize:17,fontWeight:700,letterSpacing:"-0.2px"}}>{c.campaignName}</h3>
                  <Badge status={c.status}/>
                </div>
                <p style={{fontSize:13,color:C.ink60,marginBottom:12}}>{c.niche} · {c.currency} {c.budgetMin}–{c.budgetMax} · Submitted {fmt(c.submittedAt)}</p>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{(c.platforms||[]).map(p=><Pill key={p} bg={C.ink05} color={C.ink60}>{p}</Pill>)}</div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

// ─── Admin Panel ──────────────────────────────────────────────────────────────
function Admin({ user, onLogout }) {
  const [tab,setTab]=useState("campaigns");
  const [campaigns,setCampaigns]=useState([]); const [pitches,setPitches]=useState([]); const [notifs,setNotifs]=useState([]);
  const [selCamp,setSelCamp]=useState(null); const [selPitch,setSelPitch]=useState(null);
  const [noteText,setNoteText]=useState(""); const [campNote,setCampNote]=useState("");
  const [toast,setToast]=useState("");

  const reload=async()=>{ setCampaigns(await db.get(KEYS.campaigns)||SEED_CAMPAIGNS); setPitches(await db.get(KEYS.pitches)||SEED_PITCHES); setNotifs(await db.get(KEYS.notifications)||[]); };
  useEffect(()=>{ reload(); },[]);

  const showToast=msg=>{ setToast(msg); setTimeout(()=>setToast(""),3000); };
  const upCampStatus=async(id,status)=>{ const u=campaigns.map(c=>c.id===id?{...c,status}:c); await db.set(KEYS.campaigns,u); setCampaigns(u); };
  const saveCampNote=async(id)=>{ const u=campaigns.map(c=>c.id===id?{...c,internalNotes:campNote}:c); await db.set(KEYS.campaigns,u); setCampaigns(u); showToast("Note saved"); };
  const upPitchStatus=async(pid,status)=>{
    const u=pitches.map(p=>p.id===pid?{...p,status,adminReviewed:true}:p); await db.set(KEYS.pitches,u); setPitches(u);
    if(selPitch?.id===pid) setSelPitch(p=>({...p,status,adminReviewed:true}));
    if(status==="Selected"){ const ns=await db.get(KEYS.notifications)||[]; const camp=campaigns.find(c=>c.id===selPitch?.campaignId); await db.set(KEYS.notifications,[...ns,{id:uid(),type:"pitch_selected",message:`Pitch selected for "${camp?.campaignName||"campaign"}"`,createdAt:new Date().toISOString(),read:false}]); showToast("Pitch selected — brand will be notified"); }
    else showToast(`Pitch status updated to ${status}`);
  };
  const saveNote=async()=>{ if(!selPitch)return; const u=pitches.map(p=>p.id===selPitch.id?{...p,internalNotes:noteText}:p); await db.set(KEYS.pitches,u); setPitches(u); setSelPitch(p=>({...p,internalNotes:noteText})); showToast("Note saved"); };
  const upInfStatus=async(pid,infId,status)=>{ const u=pitches.map(p=>p.id===pid?{...p,influencers:p.influencers.map(i=>i.id===infId?{...i,status}:i)}:p); await db.set(KEYS.pitches,u); setPitches(u); setSelPitch(p=>p?{...p,influencers:p.influencers.map(i=>i.id===infId?{...i,status}:i)}:p); };
  const markAllRead=async()=>{ const u=notifs.map(n=>({...n,read:true})); await db.set(KEYS.notifications,u); setNotifs(u); };
  const exportCSV=(pitch)=>{
    const camp=campaigns.find(c=>c.id===pitch.campaignId);
    const rows=[["Campaign","Brand","Agency","Creator Name","Handle","Platform","Followers","Engagement","Rate Card","Status"],...pitch.influencers.map(i=>[camp?.campaignName,camp?.brandName,pitch.agencyName,i.name,i.handle,i.platform,i.followers,i.engagement,i.rateCard,i.status||"—"])];
    const csv=rows.map(r=>r.join(",")).join("\n"); const blob=new Blob([csv],{type:"text/csv"}); const url=URL.createObjectURL(blob); const a=document.createElement("a"); a.href=url; a.download=`braco-${pitch.id}.csv`; a.click(); showToast("CSV exported");
  };

  const campPitches=selCamp?pitches.filter(p=>p.campaignId===selCamp.id):[];
  const unread=notifs.filter(n=>!n.read).length;
  const totalPitches=pitches.length;
  const byNiche={}; campaigns.forEach(c=>{ byNiche[c.niche]=(byNiche[c.niche]||0)+pitches.filter(p=>p.campaignId===c.id).length; });
  const topNiche=Object.entries(byNiche).sort((a,b)=>b[1]-a[1])[0];

  const navItems=[
    {id:"campaigns",label:"Campaigns",icon:<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="1" y="1" width="5.5" height="5.5" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><rect x="8.5" y="1" width="5.5" height="5.5" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><rect x="1" y="8.5" width="5.5" height="5.5" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><rect x="8.5" y="8.5" width="5.5" height="5.5" rx="1.5" stroke="currentColor" strokeWidth="1.5"/></svg>},
    {id:"pitches",label:"All Pitches",icon:<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M2 3.5h11M2 7.5h7M2 11.5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,badge:pitches.filter(p=>!p.adminReviewed).length},
    {id:"analytics",label:"Analytics",icon:<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M2 11L5 7.5L8 9.5L12 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>},
    {id:"notifications",label:"Notifications",icon:<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.5 1.5C5.29 1.5 3.5 3.29 3.5 5.5v3L1.5 10.5h12l-2-2v-3c0-2.21-1.79-4-4-4z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/><path d="M6 12.5a1.5 1.5 0 003 0" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>,badge:unread},
  ];

  return (
    <div style={{minHeight:"100vh",display:"flex",background:C.ink05}}>
      <GS/>
      {/* Toast */}
      {toast&&<div className="fi" style={{position:"fixed",bottom:28,right:28,background:C.ink,color:"#fff",padding:"12px 20px",borderRadius:12,zIndex:9999,fontSize:14,fontWeight:500,border:`1px solid ${C.ink80}`}}>{toast}</div>}

      {/* Sidebar */}
      <div style={{width:236,background:"#0B0D12",display:"flex",flexDirection:"column",position:"fixed",top:0,bottom:0,left:0,overflowY:"auto",zIndex:50}}>
        <div style={{padding:"20px 20px 18px",borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
          <Logo size={20} light/>
        </div>
        <div style={{padding:"6px 10px",flex:1}}>
          <div style={{fontSize:10,fontWeight:600,letterSpacing:"0.1em",textTransform:"uppercase",color:"rgba(255,255,255,0.25)",padding:"14px 10px 6px"}}>Workspace</div>
          {navItems.map(item=>{
            const active=tab===item.id;
            return (
              <button key={item.id} onClick={()=>{setTab(item.id);setSelCamp(null);setSelPitch(null);if(item.id==="notifications")markAllRead();}}
                style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"9px 12px",borderRadius:8,border:"none",background:active?"rgba(255,255,255,0.07)":"transparent",color:active?"#fff":"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:13,fontWeight:active?500:400,marginBottom:2,textAlign:"left",transition:"all 0.12s"}}>
                <span style={{color:active?C.green:"rgba(255,255,255,0.3)",flexShrink:0}}>{item.icon}</span>
                <span style={{flex:1}}>{item.label}</span>
                {item.badge>0&&<span style={{background:item.id==="notifications"?C.red:C.amber,color:"#fff",borderRadius:100,fontSize:10,padding:"1px 6px",fontWeight:700}}>{item.badge}</span>}
              </button>
            );
          })}
        </div>
        <div style={{padding:"14px 18px",borderTop:"1px solid rgba(255,255,255,0.06)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
            <div style={{width:34,height:34,borderRadius:"50%",background:`linear-gradient(135deg,${C.green},${C.greenLight})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:700,color:"#fff"}}>{user.name[0]}</div>
            <div><div style={{fontSize:13,color:"rgba(255,255,255,0.85)",fontWeight:500,lineHeight:1.2}}>{user.name}</div><div style={{fontSize:11,color:"rgba(255,255,255,0.3)"}}>Administrator</div></div>
          </div>
          <button onClick={onLogout} style={{width:"100%",padding:"8px",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.45)",borderRadius:8,cursor:"pointer",fontSize:12}}>Sign out</button>
        </div>
      </div>

      {/* Main content */}
      <div style={{marginLeft:236,flex:1,minWidth:0}}>
        {/* Topbar */}
        <div style={{background:C.white,borderBottom:`1px solid ${C.ink10}`,padding:"0 36px",height:56,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:40}}>
          <h2 style={{fontSize:16,fontWeight:700,color:C.ink}}>
            {tab==="campaigns"?selCamp?selCamp.campaignName:"Campaigns":tab==="pitches"?"All Pitches":tab==="analytics"?"Analytics":"Notifications"}
          </h2>
          <Btn variant="ghost" size="xs" onClick={reload}>↻ Refresh</Btn>
        </div>

        <div style={{padding:"28px 36px"}}>

          {/* ── CAMPAIGNS LIST ── */}
          {tab==="campaigns"&&!selCamp&&(
            <div className="fi">
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
                {[[campaigns.length,"Total campaigns",""],[ campaigns.filter(c=>c.status==="Open").length,"Open",C.green],[pitches.filter(p=>!p.adminReviewed).length,"Needs your review",C.amber],[campaigns.filter(c=>c.status==="Reviewing").length,"Reviewing",C.blue]].map(([v,l,accent])=>(
                  <Card key={l} style={{padding:"16px 18px"}}>
                    <div style={{fontSize:12,color:C.ink60,fontWeight:500,marginBottom:6}}>{l}</div>
                    <div style={{fontFamily:"'Fraunces',serif",fontSize:36,fontWeight:400,color:accent||C.ink}}>{v}</div>
                  </Card>
                ))}
              </div>
              <Card style={{overflow:"hidden"}}>
                <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.ink10}`,background:C.ink05}}>
                  <h3 style={{fontSize:14,fontWeight:600,color:C.ink60,letterSpacing:"0.03em",textTransform:"uppercase",fontSize:12}}>All campaigns</h3>
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:14}}>
                    <thead>
                      <tr style={{background:C.white}}>
                        {["Campaign","Brand","Niche","Budget","Deadline","Pitches","Status",""].map(h=>(
                          <th key={h} style={{padding:"10px 16px",textAlign:"left",fontSize:12,color:C.ink40,fontWeight:600,letterSpacing:"0.04em",borderBottom:`1px solid ${C.ink10}`,whiteSpace:"nowrap"}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {campaigns.map(c=>(
                        <tr key={c.id} className="hr" style={{borderBottom:`1px solid ${C.ink05}`}}>
                          <td style={{padding:"12px 16px"}}>
                            <span style={{cursor:"pointer",color:C.green,fontWeight:600}} onClick={()=>{setSelCamp(c);setCampNote(c.internalNotes||"");}}>{c.campaignName}</span>
                          </td>
                          <td style={{padding:"12px 16px",color:C.ink80,fontSize:13}}>{c.brandName}</td>
                          <td style={{padding:"12px 16px"}}><Pill bg={(NICHE_COLORS[c.niche]||[C.ink05,C.ink60])[0]} color={(NICHE_COLORS[c.niche]||[C.ink05,C.ink60])[1]}>{c.niche}</Pill></td>
                          <td style={{padding:"12px 16px",fontSize:13,fontWeight:600}}>{c.currency} {c.budgetMin}–{c.budgetMax}</td>
                          <td style={{padding:"12px 16px",fontSize:12,color:C.ink60,whiteSpace:"nowrap"}}>{c.deadline||"—"}</td>
                          <td style={{padding:"12px 16px",textAlign:"center"}}>
                            <span style={{fontFamily:"'Fraunces',serif",fontSize:22,fontWeight:400,color:pitches.filter(p=>p.campaignId===c.id).length>0?C.ink:C.ink20}}>{pitches.filter(p=>p.campaignId===c.id).length}</span>
                          </td>
                          <td style={{padding:"12px 16px"}}><Badge status={c.status}/></td>
                          <td style={{padding:"12px 16px"}}>
                            <select value={c.status} onChange={e=>upCampStatus(c.id,e.target.value)} style={{fontSize:12,padding:"5px 10px",border:`1px solid ${C.ink20}`,borderRadius:8,color:C.ink,background:C.white}}>
                              {["Open","Reviewing","Closed"].map(s=><option key={s}>{s}</option>)}
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          )}

          {/* ── CAMPAIGN DETAIL ── */}
          {tab==="campaigns"&&selCamp&&(
            <div className="fi">
              <button onClick={()=>{setSelCamp(null);setSelPitch(null);}} style={{background:"none",border:"none",cursor:"pointer",color:C.ink60,fontSize:13,display:"flex",alignItems:"center",gap:6,marginBottom:22}}>← Back to campaigns</button>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:22}}>
                <div>
                  <h1 style={{fontFamily:"'Fraunces',serif",fontSize:30,fontWeight:400,letterSpacing:"-0.4px",marginBottom:4}}>{selCamp.campaignName}</h1>
                  <p style={{color:C.ink60,fontSize:14}}>{selCamp.brandName} · {selCamp.niche}</p>
                </div>
                <div style={{display:"flex",gap:10,alignItems:"center"}}>
                  <Badge status={selCamp.status}/>
                  <select value={selCamp.status} onChange={e=>{upCampStatus(selCamp.id,e.target.value);setSelCamp(p=>({...p,status:e.target.value}));}} style={{fontSize:13,padding:"7px 12px",border:`1px solid ${C.ink20}`,borderRadius:8,background:C.white,color:C.ink}}>
                    {["Open","Reviewing","Closed"].map(s=><option key={s}>{s}</option>)}
                  </select>
                </div>
              </div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 360px",gap:18,marginBottom:22}}>
                <Card style={{padding:"20px 24px"}}>
                  <div style={{display:"inline-flex",alignItems:"center",gap:7,padding:"4px 12px",background:C.amberBg,borderRadius:100,fontSize:12,fontWeight:500,color:C.amberText,marginBottom:16}}>🔒 Brand contact — visible to you only</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:14}}>
                    {[["Contact name",selCamp.contactName],["Contact email",selCamp.contactEmail],["Budget",`${selCamp.currency} ${selCamp.budgetMin}–${selCamp.budgetMax}`],["Timeline",selCamp.timeline],["Deadline",selCamp.deadline],["Platforms",(selCamp.platforms||[]).join(", ")]].map(([l,v])=>(
                      <div key={l}>
                        <div style={{fontSize:11,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:3}}>{l}</div>
                        <div style={{fontSize:13,fontWeight:500,color:C.ink}}>{v||"—"}</div>
                      </div>
                    ))}
                  </div>
                  {selCamp.contentGuidelines&&<div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${C.ink10}`}}>
                    <div style={{fontSize:11,color:C.ink40,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",marginBottom:5}}>Content guidelines</div>
                    <p style={{fontSize:13,color:C.ink80,lineHeight:1.7}}>{selCamp.contentGuidelines}</p>
                  </div>}
                </Card>
                <div style={{background:C.amberBg,border:`1px solid ${C.amber}25`,borderRadius:16,padding:"20px 22px"}}>
                  <div style={{fontSize:12,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase",color:C.amberText,marginBottom:10}}>Your internal notes</div>
                  <textarea value={campNote} onChange={e=>setCampNote(e.target.value)} rows={5} style={{...iS({fontSize:13,resize:"none",background:"rgba(255,255,255,0.75)",border:`1px solid ${C.amber}35`})}} placeholder="Private notes about this campaign…"/>
                  <Btn size="sm" variant="ghost" onClick={()=>saveCampNote(selCamp.id)} style={{marginTop:10}}>Save note</Btn>
                </div>
              </div>

              <h2 style={{fontSize:18,fontWeight:700,marginBottom:14}}>Pitches <span style={{color:C.ink60,fontWeight:400,fontSize:16}}>({campPitches.length})</span></h2>
              {campPitches.length===0?<Card style={{padding:"40px",textAlign:"center"}}><p style={{color:C.ink60}}>No pitches for this campaign yet.</p></Card>:campPitches.map(pitch=>(
                <Card key={pitch.id} style={{marginBottom:14,overflow:"hidden",border:`1px solid ${selPitch?.id===pitch.id?C.green:C.ink10}`,cursor:"pointer"}} onClick={()=>{setSelPitch(pitch);setNoteText(pitch.internalNotes||"");}}>
                  {selPitch?.id===pitch.id&&<div style={{height:3,background:C.green}}/>}
                  <div style={{padding:"18px 22px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:selPitch?.id===pitch.id?12:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:12}}>
                        <div style={{width:38,height:38,borderRadius:"50%",background:C.purpleBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,fontWeight:700,color:C.purpleText,flexShrink:0}}>{pitch.agencyName[0]}</div>
                        <div>
                          <div style={{fontWeight:600,fontSize:15,color:C.ink}}>{pitch.agencyName}</div>
                          <div style={{fontSize:12,color:C.ink60}}>{pitch.influencers.length} creator{pitch.influencers.length!==1?"s":""} · {fmt(pitch.submittedAt)}{!pitch.adminReviewed&&<span style={{color:C.amber,fontWeight:600}}> · Needs your review</span>}</div>
                        </div>
                      </div>
                      <Badge status={pitch.status}/>
                    </div>

                    {selPitch?.id===pitch.id&&(
                      <div style={{borderTop:`1px solid ${C.ink10}`,paddingTop:14}} onClick={e=>e.stopPropagation()}>
                        {pitch.pitchNote&&<div style={{background:C.ink05,borderRadius:10,padding:"12px 14px",fontSize:13,color:C.ink80,fontStyle:"italic",lineHeight:1.65,marginBottom:16}}>"{pitch.pitchNote}"</div>}
                        <div style={{marginBottom:16}}>
                          {pitch.influencers.map((inf,i)=>(
                            <div key={inf.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:i<pitch.influencers.length-1?`1px solid ${C.ink05}`:"none",gap:12}}>
                              <div style={{flex:1,minWidth:0}}>
                                <div style={{fontWeight:600,fontSize:14,color:C.ink,marginBottom:2}}>{inf.name} <span style={{color:C.green,fontWeight:500,fontSize:13}}>{inf.handle}</span></div>
                                <div style={{fontSize:12,color:C.ink60}}>{inf.platform} · {inf.followers} followers · {inf.engagement} eng. · <strong style={{color:C.ink}}>{inf.rateCard}</strong></div>
                                {inf.sampleLinks&&<a href={inf.sampleLinks} style={{fontSize:12,color:C.green,fontWeight:500}} target="_blank" rel="noreferrer">View content ↗</a>}
                              </div>
                              <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                                {inf.status&&<Badge status={inf.status}/>}
                                <button onClick={()=>upInfStatus(pitch.id,inf.id,"Approved")} title="Approve" style={{width:30,height:30,borderRadius:8,background:C.greenBg,border:`1px solid ${C.green}30`,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                  <svg width="11" height="9" viewBox="0 0 11 9" fill="none"><path d="M1 4.5L3.8 7.5L10 1" stroke={C.green} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                </button>
                                <button onClick={()=>upInfStatus(pitch.id,inf.id,"Shortlisted")} title="Shortlist" style={{width:30,height:30,borderRadius:8,background:C.blueBg,border:`1px solid ${C.blue}30`,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,color:C.blue}}>★</button>
                                <button onClick={()=>upInfStatus(pitch.id,inf.id,"Rejected")} title="Reject" style={{width:30,height:30,borderRadius:8,background:C.redBg,border:`1px solid ${C.red}30`,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                  <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1 1L8 8M8 1L1 8" stroke={C.red} strokeWidth="1.7" strokeLinecap="round"/></svg>
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div style={{background:C.amberBg,border:`1px solid ${C.amber}30`,borderRadius:10,padding:"14px 16px",marginBottom:14}}>
                          <div style={{fontSize:12,fontWeight:600,color:C.amberText,marginBottom:8,letterSpacing:"0.03em",textTransform:"uppercase"}}>Your personal note</div>
                          <textarea value={noteText} onChange={e=>setNoteText(e.target.value)} rows={2} style={iS({fontSize:13,background:"rgba(255,255,255,0.7)",border:`1px solid ${C.amber}30`,resize:"none"})} placeholder="Private thoughts on this pitch…"/>
                          <Btn size="sm" variant="ghost" onClick={saveNote} style={{marginTop:8}}>Save</Btn>
                        </div>
                        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                          <Btn size="sm" variant="ghost" onClick={()=>upPitchStatus(pitch.id,"Reviewing")}>Mark reviewing</Btn>
                          <Btn size="sm" variant="accent" onClick={()=>upPitchStatus(pitch.id,"Selected")}>🎯 Select this pitch</Btn>
                          <Btn size="sm" variant="danger" onClick={()=>upPitchStatus(pitch.id,"Rejected")}>Reject</Btn>
                          <Btn size="sm" variant="secondary" onClick={()=>exportCSV(pitch)}>↓ Export CSV</Btn>
                        </div>
                      </div>
                    )}
                  </div>
                </Card>
              ))}
            </div>
          )}

          {/* ── ALL PITCHES ── */}
          {tab==="pitches"&&(
            <div className="fi">
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
                <p style={{color:C.ink60}}>{pitches.length} total submissions</p>
                {pitches.filter(p=>!p.adminReviewed).length>0&&<Pill bg={C.amberBg} color={C.amberText}>{pitches.filter(p=>!p.adminReviewed).length} need your review</Pill>}
              </div>
              {pitches.map(pitch=>{
                const camp=campaigns.find(c=>c.id===pitch.campaignId);
                return (
                  <Card key={pitch.id} style={{marginBottom:12,overflow:"hidden"}}>
                    <div style={{padding:"16px 20px"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                        <div style={{display:"flex",alignItems:"center",gap:12}}>
                          <div style={{width:36,height:36,borderRadius:"50%",background:C.purpleBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:700,color:C.purpleText}}>{pitch.agencyName[0]}</div>
                          <div>
                            <div style={{fontWeight:600,fontSize:14}}>{pitch.agencyName}</div>
                            <div style={{fontSize:12,color:C.ink60}}>For: {camp?.campaignName||"Unknown"} · {fmt(pitch.submittedAt)}</div>
                          </div>
                        </div>
                        <div style={{display:"flex",gap:8,alignItems:"center"}}>
                          {!pitch.adminReviewed&&<Pill bg={C.amberBg} color={C.amberText}>Needs review</Pill>}
                          <Badge status={pitch.status}/>
                          <Btn size="sm" variant="outline" onClick={()=>{setSelCamp(camp);setSelPitch(pitch);setNoteText(pitch.internalNotes||"");setTab("campaigns");}}>Review →</Btn>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {pitch.influencers.slice(0,4).map(i=><Pill key={i.id} bg={C.purpleBg} color={C.purpleText}>{i.name} · {i.platform}</Pill>)}
                        {pitch.influencers.length>4&&<Pill bg={C.ink05} color={C.ink60}>+{pitch.influencers.length-4} more</Pill>}
                      </div>
                    </div>
                  </Card>
                );
              })}
              {pitches.length===0&&<Card style={{padding:"60px",textAlign:"center"}}><p style={{color:C.ink60}}>No pitches submitted yet.</p></Card>}
            </div>
          )}

          {/* ── ANALYTICS ── */}
          {tab==="analytics"&&(
            <div className="fi">
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
                {[[campaigns.length,"Total campaigns",C.ink],[campaigns.filter(c=>c.status==="Open").length,"Open campaigns",C.green],[totalPitches,"Total pitches",C.purple],[pitches.filter(p=>p.status==="Selected").length,"Selected pitches",C.amber]].map(([v,l,accent])=>(
                  <Card key={l} style={{padding:"18px 20px"}}>
                    <div style={{fontSize:12,color:C.ink60,fontWeight:500,marginBottom:8}}>{l}</div>
                    <div style={{fontFamily:"'Fraunces',serif",fontSize:40,fontWeight:400,color:accent}}>{v}</div>
                  </Card>
                ))}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
                <Card style={{padding:"20px 22px"}}>
                  <h3 style={{fontSize:14,fontWeight:700,marginBottom:18,color:C.ink}}>Pitches per campaign</h3>
                  {campaigns.map(c=>{
                    const count=pitches.filter(p=>p.campaignId===c.id).length;
                    const pct=Math.min(100,(count/Math.max(1,totalPitches))*100*campaigns.length);
                    return (
                      <div key={c.id} style={{marginBottom:14}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                          <span style={{fontSize:13,color:C.ink80,fontWeight:500}}>{c.campaignName}</span>
                          <span style={{fontSize:13,fontWeight:700,fontFamily:"'Fraunces',serif"}}>{count}</span>
                        </div>
                        <div style={{background:C.ink10,borderRadius:100,height:6}}>
                          <div style={{background:C.green,borderRadius:100,height:6,width:`${pct}%`}}/>
                        </div>
                      </div>
                    );
                  })}
                </Card>
                <Card style={{padding:"20px 22px"}}>
                  <h3 style={{fontSize:14,fontWeight:700,marginBottom:18,color:C.ink}}>Top niches by pitch volume</h3>
                  {Object.entries(byNiche).sort((a,b)=>b[1]-a[1]).map(([niche,count])=>{
                    const nc=NICHE_COLORS[niche]||[C.ink05,C.ink60];
                    return (
                      <div key={niche} style={{marginBottom:14}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                          <span style={{fontSize:13,color:C.ink80,fontWeight:500}}>{niche}</span>
                          <span style={{fontSize:13,fontWeight:700,fontFamily:"'Fraunces',serif"}}>{count}</span>
                        </div>
                        <div style={{background:C.ink10,borderRadius:100,height:6}}>
                          <div style={{background:nc[1],borderRadius:100,height:6,width:`${Math.min(100,(count/Math.max(1,totalPitches))*100)}%`,opacity:0.75}}/>
                        </div>
                      </div>
                    );
                  })}
                  {totalPitches===0&&<p style={{fontSize:13,color:C.ink60}}>No pitch data yet.</p>}
                  {topNiche&&<div style={{marginTop:14,padding:"10px 12px",background:C.greenBg,borderRadius:8,fontSize:13,color:C.greenText,fontWeight:500}}>Top niche: {topNiche[0]}</div>}
                </Card>
              </div>
            </div>
          )}

          {/* ── NOTIFICATIONS ── */}
          {tab==="notifications"&&(
            <div className="fi">
              {notifs.length===0?<Card style={{padding:"60px",textAlign:"center"}}><p style={{color:C.ink60}}>No notifications yet.</p></Card>:
                [...notifs].reverse().map(n=>(
                  <div key={n.id} style={{background:C.white,border:`1px solid ${n.read?C.ink10:C.green+"40"}`,borderLeft:`3px solid ${n.read?C.ink20:C.green}`,borderRadius:12,padding:"14px 18px",marginBottom:10}}>
                    <div style={{fontWeight:n.read?400:600,fontSize:14,color:n.read?C.ink80:C.ink,marginBottom:4}}>{n.message}</div>
                    <div style={{fontSize:12,color:C.ink40}}>{fmt(n.createdAt)}</div>
                  </div>
                ))
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── App Root ─────────────────────────────────────────────────────────────────
export default function App() {
  const [page,setPage]=useState("landing"); const [user,setUser]=useState(null); const [authMode,setAuthMode]=useState("login"); const [ready,setReady]=useState(false);
  useEffect(()=>{
    db.get(KEYS.users).then(u=>{if(!u)db.set(KEYS.users,SEED_USERS);});
    db.get(KEYS.campaigns).then(c=>{if(!c)db.set(KEYS.campaigns,SEED_CAMPAIGNS);});
    db.get(KEYS.pitches).then(p=>{if(!p)db.set(KEYS.pitches,SEED_PITCHES);});
    setReady(true);
  },[]);
  const nav=p=>{ if(p==="login"||p==="register"){setAuthMode(p==="login"?"login":"register");setPage("auth");return;} setPage(p); };
  const handleAuth=u=>{ setUser(u); if(u.role==="admin")setPage("admin"); else if(u.role==="influencer")setPage("dashboard"); else setPage("brand-dashboard"); };
  const logout=()=>{ setUser(null); setPage("landing"); };
  if(!ready) return <div style={{height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:C.ink05}}><style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;1,9..144,400&display=swap');`}</style><div style={{fontFamily:"Fraunces,Georgia,serif",fontSize:26,color:C.ink20,letterSpacing:"-0.5px"}}>braco</div></div>;
  if(page==="landing") return <Landing onNav={nav} user={user} onLogout={logout}/>;
  if(page==="auth") return <Auth mode={authMode} onAuth={handleAuth} onSwitch={m=>setAuthMode(m)} onNav={nav}/>;
  if(page==="brand-brief") return <BrandBrief onBack={()=>nav("landing")}/>;
  if(page==="catalog") return <Catalog user={user} onNav={nav} onLogout={logout} onLoginRequired={()=>{setAuthMode("login");setPage("auth");}}/>;
  if(page==="admin"&&user?.role==="admin") return <Admin user={user} onLogout={logout}/>;
  if(page==="dashboard"&&user?.role==="influencer") return <InflDash user={user} onNav={nav} onLogout={logout}/>;
  if(page==="brand-dashboard"&&user?.role==="brand") return <BrandDash user={user} onNav={nav} onLogout={logout}/>;
  return <Landing onNav={nav} user={user} onLogout={logout}/>;
}
